import React, { useCallback, useMemo, useRef, useState } from "react";
import { Table } from "../UI/Table";
import { StyledHolidayContainer } from "./styles";
import Button from "../UI/Button";
import { translate } from "../../utils/translations/translate";
import { ActionRenderer } from "./ActionRenderer";
import { FullScreenModal } from "../UI/Modal";
import { CreateEditProjectTask } from "./CreateEditProjectTask";
import { Loader } from "../Loader/Loader";
import Tooltip from '@mui/material/Tooltip';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import IconButton from '@mui/material/IconButton';
import { Alert } from "../UI/Alert";
import { DeleteConfirmationModal } from "./DeleteConfirmationModal";
import { generateTasksReport } from "../../utils/reports";
import moment from "moment";
import { DATE_TIME_FORMAT } from "../../utils/constants";
const dateFormatter = (params) => {
  if (params.value) {
    return moment(new Date(params.value)).format(DATE_TIME_FORMAT.DISPLAY);
  }
  return "";
};
const booleanFormatter = ({value})=>{
    if(value){
        return "Yes"
    }
    return "No"
}
export const ProjectTaskSettings = ({
  projectTasksData,
  toastInfo,
  onCreateEdit,
  onDeleteTask,
  isLoading,
  onToastClose
}) => {
  const [showCreateOrEditDialog, setShowCreateOrEditDialog] = useState(false);
  const [selectedProjectTaskData, setSelectedProjectTaskData] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const projectTaskToBeDeletedRef = useRef(null);
  const handleEdit = useCallback((data) => {
    setSelectedProjectTaskData(data);
    setShowCreateOrEditDialog(true);
  }, []);
  const gridRef = useRef(null);
  const handleDelete = useCallback(({ taskId }) => {
    projectTaskToBeDeletedRef.current = taskId;
    setShowDeleteModal(true);
  }, []);
  const handleDeleteModalClose = useCallback(() => {
    setShowDeleteModal(false);
  }, []);
  const onConfirmProjectTaskDeletion = useCallback(() => {
    onDeleteTask(projectTaskToBeDeletedRef.current);
    setShowDeleteModal(false);
  }, [onDeleteTask]);
  const handleCreateOrEditSubmit = useCallback(
    (savedData) => {
      setShowCreateOrEditDialog(false);
      setSelectedProjectTaskData(null);
      onCreateEdit(savedData);
    },
    [onCreateEdit]
  );

 
  const columnDefs = [
    {
      headerName: "Name",
      field: "taskName",
      sortable: true,
      filter: false,
      width: 400,
    },
    {
      headerName: "Created On",
      field: "taskCreatedOn",
      sortable: true,
      filter: false,
      width: 280,
      cellRenderer: dateFormatter,
    },
    {
      headerName: "Active",
      field: "isActive",
      sortable: true,
      filter: false,
      width: 200,
      cellRenderer: booleanFormatter,
    },
    {
      headerName: "Actions",
      field: "action",
      sortable: false,
      filter: false,
      width: 190,
      flex:1,
      cellRenderer: ActionRenderer,
      cellRendererParams: {
        showEditIcon:true,
        showDeleteIcon:true,
        onEdit: handleEdit,
        onDelete: handleDelete,
      },
    },
  ];
  const sortedListData = useMemo(()=>{
    const sortedTasks = projectTasksData.slice().sort((taskA,taskB)=>taskA.taskId - taskB.taskId)
    return sortedTasks;
  },[projectTasksData])
  const handleDownload = () => {
    const prepareListForDownload = sortedListData.map(task=>{
     const {taskName,taskCreatedOn,isActive} = task;
     return {
       TaskName:taskName,
       Created_On:moment(new Date(taskCreatedOn)).format(DATE_TIME_FORMAT.DISPLAY),
       Status:isActive ? "Active":"Inactive"
     }
    })
    generateTasksReport(prepareListForDownload);
 };
  return (
    <StyledHolidayContainer>
      {toastInfo && (
        <Alert {...toastInfo} onToastClose={onToastClose} />
      )}
      <header className="tma_holiday_header">
        {projectTasksData?.length > 0 && 
        <Tooltip title={translate("labels.downloadList")} arrow placement="top-start">
        <IconButton>
          <DownloadForOfflineIcon onClick={handleDownload} />
        </IconButton>
      </Tooltip>
        }
        <Button
          text={translate("labels.addNewTask")}
          variantStyle="primary"
          className={"tma_add_holiday"}
          onClick={() => setShowCreateOrEditDialog(true)}
        />
      </header>
      <div className="tma_holiday_table projects">
        <Table
          columns={columnDefs}
          rowSelection={"single"}
          rowData={sortedListData}
          showPagination={false}
          gridRef={gridRef}
          autoFit={false}
        />
      </div>

      {showCreateOrEditDialog && (
        <FullScreenModal
          onClose={() => {
            setShowCreateOrEditDialog(false);
            setSelectedProjectTaskData(null);
          }}
        >
          <CreateEditProjectTask
            isCreateMode={selectedProjectTaskData ? false : true}
            savedData={selectedProjectTaskData}
            onSave={handleCreateOrEditSubmit}
          />
        </FullScreenModal>
      )}
      {isLoading && <Loader />}
      {showDeleteModal && (
        <DeleteConfirmationModal
          title={translate("labels.deleteProjectTask")}
          infoText={translate("labels.deleteTaskInfoMsg")}
          onClose={handleDeleteModalClose}
          onConfirm={onConfirmProjectTaskDeletion}
        />
      )}
    </StyledHolidayContainer>
  );
};
